
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { CameraGroup } from '@/api';
import { dataModule } from '@/store/data';
import NSelect from '@/uikit/select/NSelect.vue';
import { generateLoadSearchMethodsByLVM, getExcludeFilterFunctionById } from '@/components/common/filter/filters/utils';

const VideoArchiveGroupId = -1;

@Options({
  name: 'CameraGroupName',
  components: { NSelect }
})
export default class CameraGroupName extends Vue {
  @Prop({ type: Number, required: true })
  readonly modelValue!: number;

  @Prop({ type: Boolean, default: false })
  readonly accent?: boolean;

  @Prop({ type: Boolean, default: false })
  readonly readonly?: boolean;

  @Prop({ type: Boolean, default: true })
  readonly excludeVideoArchive?: boolean;

  @Prop({ type: String, required: false })
  readonly placeholder?: string;

  private name = '...';

  created() {
    this.loadName();
  }

  updateValue(value: number) {
    this.$emit('update:modelValue', value);
  }

  @Watch('modelValue')
  async loadName() {
    const group = await dataModule.cameraGroupsModule.getById(this.modelValue);
    const groups = [group];
    this.name = groups.length ? groups.map((v) => v?.name).join(', ') : '[camera-group: not found]';
  }

  get props() {
    if (this.excludeVideoArchive){
      return { ...generateLoadSearchMethodsByLVM(dataModule.cameraGroupsModule,{
          filterFunction: getExcludeFilterFunctionById([-1])
        }) 
      };
    }
    return { ...generateLoadSearchMethodsByLVM(dataModule.cameraGroupsModule)};
  }
}
